import React, { memo, useCallback } from 'react'
import { FunnelIcon } from '@heroicons/react/24/outline'

const FiltersComponent = ({ filters, setFilters, showFilters }) => {
  // Optimized filter change handlers to prevent unnecessary re-renders
  const handleFilterChange = useCallback(
    (key, value) => {
      setFilters({ ...filters, [key]: value })
    },
    [filters, setFilters]
  )

  // Optimized clear filters handler
  const handleClearFilters = useCallback(() => {
    setFilters({ status: '', gender: '', civil_status: '' })
  }, [setFilters])

  if (!showFilters) return null

  return (
    <div className='bg-gray-50  p-5 border animate-in slide-in-from-top duration-300'>
      {/* <div className='flex items-center mb-4'>
        <FunnelIcon className='w-5 h-5 mr-2 text-blue-600' />
        <h3 className='text-lg font-medium text-gray-900'>Filter Residents</h3>
      </div> */}

      <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
        <div className='flex flex-col'>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Status
          </label>
          <select
            value={filters.status}
            onChange={(e) => handleFilterChange('status', e.target.value)}
            className='w-full border border-gray-300 rounded-lg px-4 py-2 '
          >
            <option value=''>All Status</option>
            <option value='active'>Active</option>
            <option value='inactive'>Inactive</option>
            <option value='verified'>Verified</option>
            <option value='pending'>Pending</option>
          </select>
        </div>

        <div className='flex flex-col'>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Gender
          </label>
          <select
            value={filters.gender}
            onChange={(e) => handleFilterChange('gender', e.target.value)}
            className='w-full border border-gray-300 rounded-lg px-4 py-2 '
          >
            <option value=''>All Genders</option>
            <option value='male'>Male</option>
            <option value='female'>Female</option>
            <option value='other'>Other</option>
          </select>
        </div>
        <div className='flex flex-col'>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Household
          </label>
          <select
            value={filters.household}
            onChange={(e) => handleFilterChange('household', e.target.value)}
            className='w-full border border-gray-300 rounded-lg px-4 py-2 '
          >
            <option value=''>All Household</option>
            <option value='assigned'>Assigned</option>
            <option value='no_assignment'>No Assignment</option>
          </select>
        </div>
        <div className='flex flex-col'>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Category
          </label>
          <select
            value={filters.category}
            onChange={(e) => handleFilterChange('category', e.target.value)}
            className='w-full border border-gray-300 rounded-lg px-4 py-2 '
          >
            <option value=''>All Category</option>
            <option value='pwd'>PWD</option>
            <option value='senior_citizen'>Senior Citizen</option>
            <option value='solo_parent'>Solo Parent</option>
            <option value='illiterate'>Illiterate</option>
          </select>
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Monthly Income
          </label>
          <select
            value={filters.income}
            onChange={(e) => handleFilterChange('income', e.target.value)}
            className='w-full border border-gray-300 rounded-lg px-4 py-3 '
          >
            <option value='all'>All Income</option>
            <option value='0-1000'>0-1000</option>

            <option value='5000-10000,'>5000-10000,</option>
            <option value='10000-20000'>10000-20000</option>
          </select>
        </div>
        <div className='flex flex-col'>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Civil Status
          </label>
          <select
            value={filters.civil_status}
            onChange={(e) => handleFilterChange('civil_status', e.target.value)}
            className='w-full border border-gray-300 rounded-lg px-4 py-2 '
          >
            <option value=''>All Status</option>
            <option value='single'>Single</option>
            <option value='married'>Married</option>
            <option value='divorced'>Divorced</option>
            <option value='widowed'>Widowed</option>
            <option value='separated'>Separated</option>
          </select>
        </div>

        {/* <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Search</label>
          <input
            type="text"
            placeholder="Search residents..."
            value={filters.search}
            onChange={(e) => handleFilterChange('search', e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-3"
          />
        </div> */}
      </div>

      {/* <div className='mt-6 flex justify-between items-center'>
        <div className='text-sm text-gray-600'>
          Showing filtered results based on selected criteria
        </div>
        <button
          onClick={() =>
            setFilters({
              status: '',
              gender: '',
              civil_status: '',
              income: '',
              category: '',
              household: '',
            })
          }
          className='inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors'
        >
          Clear All Filters
        </button>
      </div> */}
    </div>
  )
}

export default memo(FiltersComponent)
